
import React, { useState } from "react";
import {
    IconButton,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";

const ClearCacheButton: React.FC = () => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClearAndReload = () => {
        try {
            if ("caches" in window) {
                caches.keys().then((names) => {
                    for (let name of names) {
                        caches.delete(name);
                    }
                });
            }
            window.location.reload();
        } catch (error) {
            console.error("Error limpiando caché:", error);
            window.location.reload();
        }
    };

    return (
        <>
            <Tooltip
                title="Limpiar caché y recargar"
                arrow
                componentsProps={{
                    tooltip: {
                        sx: {
                            backgroundColor: "#1D3D4D",
                            color: "#FFF",
                            fontFamily: "Montserrat",
                            fontSize: "0.875rem",
                            padding: "8px 12px",
                            borderRadius: "8px",
                        },
                    },
                    arrow: {
                        sx: {
                            color: "#1D3D4D", // Color de la flecha
                        },
                    },
                }}>
                <IconButton
                    onClick={handleClickOpen}
                    sx={{
                        color: "#336B87",
                        m: "auto",
                    }}
                >
                    <AutorenewRoundedIcon />
                </IconButton>
            </Tooltip>

            {/* Modal de confirmación */}
            <Dialog
                open={open}
                onClose={handleClose}
                BackdropProps={{
                    sx: {
                        backgroundColor: "rgba(29, 61, 77, 0.6)",
                    },
                }}
                PaperProps={{
                    sx: {
                        backgroundColor: "#ffffff",
                        borderRadius: 2,
                        padding: 0,
                        minWidth: 320,
                        fontFamily: "'Montserrat', sans-serif",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: "bold",
                        color: "#336B87", 
                        fontSize: 18,
                        px: 3,
                        pt: 3,
                    }}
                >
                    ¿Confirmas que quieres limpiar Caché?
                </DialogTitle>

                <DialogContent sx={{ px: 3, pb: 2 }}>
                    <DialogContentText
                        sx={{
                            color: "rgba(0,0,0,0.6)", 
                            fontFamily: "'Montserrat', sans-serif",
                            fontSize: 14,
                            textAlign: "center",
                        }}
                    >
                        Si estás trabajando en una App y no has guardado los cambios o avance, tu trabajo se perderá.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ px: 2, pb: 2, justifyContent: "center", }}>
                    {/* Botón Cancelar */}
                    <Button
                        onClick={handleClose}
                        variant="text"
                        sx={{
                            backgroundColor: "#FFFFFF",
                            color: "#FB3748",
                            textTransform: "none",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 600,
                            borderRadius: 2,
                            "&:hover": {
                                backgroundColor: "#FB3748",
                                color: "#FFFFFF",
                            },
                        }}
                    >
                        Volver a revisar
                    </Button>

                    {/* Botón Confirmar */}
                    <Button
                        onClick={handleClearAndReload}
                        variant="contained"
                        sx={{
                            backgroundColor: "#336B87",
                            color: "#FFFFFF",
                            textTransform: "none",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 600,
                            borderRadius: 2,
                            ml: 1,
                            "&:hover": {
                                backgroundColor: "#1FC16B", 
                                color: "#FFFFFF",
                            },
                        }}
                    >
                        Limpiar Caché
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ClearCacheButton;
